import React from 'react'
import CommonInformationDetail from '../../../common/pages/secure/InformationDetail'
import Config from '../../../Config'
import PageHeader from '../../components/PageHeader'

class InformationDetail extends CommonInformationDetail {
  constructor (props) {
    super(props)
    this.apiUrl = Config.companyUserApiUrl.systemSettings
    this.userRoleUrl = 'company_user'
    this.userRole = 'companyUser'
    this.isShowingEditButton = false
    this.isShowingDeleteButton = false
  }
  renderPageNavi (editButton, deleteButton) {
    return (
      <PageHeader title='事務局からのお知らせ - 詳細' sub='こちらで事務局からのお知らせを確認できます。' history={this.props.history}>
        <ul className='nav nav-pills kw-page-actions'>
          <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
          {editButton}
          {deleteButton}
        </ul>
      </PageHeader>
    )
  }
}

export default InformationDetail



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/InformationDetail.js